// @packages
import { combineReducers } from 'redux';

// @scripts
import {
    COLLAPSE_MAIN_MENU,
    EXPAND_MAIN_MENU
} from '../actions/main-menu';

import { config } from '../config';

/**
 * @return {boolean}
 */
const isExpandedReducer = (
    state = config.initialState.mainMenu.isExpanded, action
) => {
    switch (action.type) {
        case EXPAND_MAIN_MENU:
            return true;
        case COLLAPSE_MAIN_MENU:
            return false;
        default:
            return state;
    }
};

export const mainMenuReducer = combineReducers({
    isExpanded: isExpandedReducer
});
